import React, { useEffect, useState } from 'react';
import BlockOutsService from 'external-services/blockouts-service/blockouts.service';
import { Box, Typography } from '@material-ui/core';
import { orderBy } from 'lodash';
import style from './style.module.css';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import ActionButton from 'design-v2/common/ActionButton';
import { IBlockout, NBIProject } from 'shared-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';
import { scheduleActions, setSelectedSchedule } from 'app/reducers/schedule/slice';
import { useAppDispatch } from 'app/appRoot/Store';
import classNames from 'classnames';
import DateUtilsService from 'external-services/date-utils-service';
import { LocaleService } from 'internal-services/locale/locale.service';

const dateFormat = 'hh:mm A';
export default function EditBlockouts({ exit }: { exit: () => void }) {
  const [removableId, setRemovableId] = useState<string>();
  const [hiddenServices, setHiddenServices] = useState([]);
  const [showDeleteSuccessMsg, setShowDeleteSuccessMsg] = useState(false);
  const [deletedBlockoutName, setDeletedBlockoutName] = useState('');
  const [showDeleteHiddenServiceSuccessMsg, setShowDeleteHiddenServiceSuccessMsg] = useState(false);
  const [deletedHiddenServiceName, setDeletedHiddenServiceName] = useState('');


  const dispatch = useAppDispatch();
  const isWideVersion = useSelector((state: DiaryRootState) => state.bookingCreatorSettingReducer.isWideVersion);

  const selectedDate = useSelector((state: DiaryRootState) => state.scheduleReducer.selectedDate);
  const selectedSchedule = useSelector((state: DiaryRootState) => state.scheduleReducer.selectedSchedule);
  const { blockouts } = useSelector(
    (state: DiaryRootState) => state.scheduleReducer.selectedSchedule
  );

  const removeBlockout = () => {
    const foundBlockout = blockouts.find(({ _id }) => _id === removableId);
    BlockOutsService.remove(foundBlockout).then(async () => {
      await dispatch(scheduleActions.removeBlockout({ date: selectedDate, id: foundBlockout._id }));
      setShowDeleteSuccessMsg(true);
      setDeletedBlockoutName(foundBlockout.name);
    });
  };
  const removeHiddenService = (name: string) => {
    BlockOutsService.deleteHiddenService({
      serviceIds: [removableId],
      date: DateUtilsService.dateToDateStr(selectedDate),
    }).then(() => {
      setHiddenServices(hiddenServices.filter((service) => service._id !== removableId));
      setShowDeleteHiddenServiceSuccessMsg(true);
      setDeletedHiddenServiceName(name);
    })
  }
  const generateHiddenServiceList = (hiddenServicesIds: string[]) => {
    const _hiddenServices = hiddenServicesIds.map((id) => {
      return selectedSchedule.services.find((service) => service._id === id);
    }).filter((service) => !!service).map((service) => {
      return {
        name: service.name,
        _id: service._id,
        date: selectedDate.toLocaleDateString(LocaleService.getLocale()),
      };
    });
    setHiddenServices(_hiddenServices);
  }
  useEffect(() => {
    if (selectedSchedule?.services?.length) {
      const dateStr = DateUtilsService.dateToDateStr(selectedDate);
      BlockOutsService.getHiddenServiceByDate(dateStr).then(function (dto) {
        dispatch(scheduleActions.setHiddenServices(dto.serviceIds));
        generateHiddenServiceList(dto.serviceIds);
      });
    }
  }, [selectedSchedule])

  return (
    <div className={classNames({
      [style.containerBlockout]: !isWideVersion,
      [style.containerBlockoutWideVersion]: isWideVersion,
    })}>
      <div className={style.spaceOutside}>
        <div className={style.header}>
          <div className={style.btnWrap}>
            <ActionButton
              fullWidth={true}
              variant={'secondary'}
              size={'regular'}
              text={'Close'}
              handleClick={exit}
            />
          </div>
          <span className={style.title}>Blockouts</span>
          <div></div>
        </div>
      </div>
      <div className={style.spaceMedium}>
        <div className={style.containerNew} id="blockout-container">
          <span className={style.title} style={{color: Colors.get(APP_COLORS.clrNbiMagenta), marginBottom: 10}}>Blockouts</span>
          <Typography color="textPrimary">
            This shows all available blockouts for this specific day.
          </Typography>
          <Typography color="textPrimary">
            If the blockout was created in Diary Mobile it can be deleted.
          </Typography>
          <Typography color="textPrimary" className={style.lastTips}>
            If the blockout was created in the Diary it can not be deleted in Diary Mobile. It can
            only be deleted via the Diary.
          </Typography>
          {!blockouts.length ? (
            <Typography color="textPrimary">No blockouts found</Typography>
          ) : null}
          <span className={style.newTitle}>Blockouts</span>
          {orderBy(blockouts, ['startDateTime'], ['desc']).map(
            ({ name, _id, startDateTime, endDateTime, createdBy }, index) => {
              const isLast = index === blockouts.length - 1;
              return (
                <Box
                  data-testid="blockout-item"
                  alignItems="center"
                  key={_id}
                  display="flex"
                  justifyContent="space-between"
                  padding="4px 0px"
                  style={{
                    gap: 12,
                    borderBottom: isLast
                      ? 'none'
                      : `1px solid ${Colors.get(APP_COLORS.clrGreyLight)}`,
                    background:
                      _id === removableId
                        ? Colors.get(APP_COLORS.clrWarningLight)
                        : 'unset',
                  }}
                >

                      <Box
                        alignItems="center"
                        display="flex"
                        justifyContent="space-between"
                        width="100%"
                      >
                        {/*only blockout from DM can be deleted*/}
                        {createdBy && createdBy === NBIProject.DIARY_MOBILE ? (
                          <IconButton
                            onClick={() => setRemovableId(_id)}
                            color="primary"
                            aria-label="delete blockout"
                            component="span"
                            data-testid={`delete-blockout-item-${_id}`}
                          >
                            <DeleteOutlineIcon />
                          </IconButton>
                        ) : (
                          <div className={style.emptySpace}></div>
                        )}
                        <Typography
                          className={style.ellipsis}
                          color="textPrimary"
                          style={{ flex: 2 }}
                        >
                          {name}
                        </Typography>
                        <Box marginLeft="12px" width={150}>
                          <Typography color="textPrimary">
                            {moment(startDateTime).format(dateFormat)} {LocaleService.formatDate(startDateTime, 'medium')}
                          </Typography>
                          <Typography color="textPrimary">
                            {moment(endDateTime).format(dateFormat)} {LocaleService.formatDate(endDateTime, 'medium')}
                          </Typography>
                        </Box>
                      </Box>
                      {_id === removableId ? (
                        <Button
                          onClick={removeBlockout}
                          data-testid={`confirm-delete-blockout-item-${_id}`}
                        >
                          <Typography
                            color="primary"
                            style={{ textTransform: 'none', fontWeight: 'bold' }}
                          >
                            Confirm delete?
                          </Typography>
                        </Button>
                      ) : null}
                </Box>
              );
            }
          )}
          {hiddenServices.length > 0 && <span className={style.newTitle}>Hidden Services</span>}
          {hiddenServices.map(
            ({ name, _id, date }, index) => {
              const isLast = index === hiddenServices.length - 1;
              return (
                <Box
                  data-testid="blockout-item"
                  alignItems="center"
                  key={_id}
                  display="flex"
                  justifyContent="space-between"
                  padding="4px 0px"
                  style={{
                    gap: 12,
                    borderBottom: isLast
                      ? 'none'
                      : `1px solid ${Colors.get(APP_COLORS.clrGreyLight)}`,
                    background:
                      _id === removableId
                        ? Colors.get(APP_COLORS.clrWarningLight)
                        : 'unset',
                  }}
                >
                      <Box
                        alignItems="center"
                        display="flex"
                        justifyContent="space-between"
                        width="100%"
                      >
                        <IconButton
                          onClick={() => setRemovableId(_id)}
                          color="primary"
                          aria-label="delete blockout"
                          component="span"
                          data-testid={`delete-blockout-item-${_id}`}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>

                        <Typography
                          className={style.ellipsis}
                          color="textPrimary"
                          style={{ flex: 2 }}
                        >
                          {name}
                        </Typography>
                        <Box marginLeft="12px" width={150}>
                          <Typography color="textPrimary">
                            {date}
                          </Typography>
                        </Box>
                      </Box>
                      {_id === removableId ? (
                        <Button
                          onClick={() => removeHiddenService(name)}
                          data-testid={`confirm-delete-blockout-item-${_id}`}
                        >
                          <Typography
                            color="primary"
                            style={{ textTransform: 'none', fontWeight: 'bold' }}
                          >
                            Confirm delete?
                          </Typography>
                        </Button>
                      ) : null}
                </Box>
              );
            }
          )}
          {showDeleteSuccessMsg ? (
            <Typography color="error">{`Blockout for ${deletedBlockoutName} was deleted`}</Typography>
          ) : null}
          {showDeleteHiddenServiceSuccessMsg ? (
            <Typography color="error">{`Hidden Service for ${deletedHiddenServiceName} was deleted`}</Typography>
          ) : null}
        </div>
      </div>
    </div>
  );
}
